import axios from "axios";
import {
  getBaseUrl,
  Microservice,
} from "@funded-here-interface/common/src/constant/baseUrl";
import { getApiResponseErrorMsg } from "@funded-here-interface/common/src/Utils/apiHelper";

export interface ExternalAccountConfigResponse {
  data: ExternalAccountConfigData[];
  totalRowCount: number;
}

export interface ExternalAccountConfigData {
  company: string;
  email: string;
  isFundPullEnabled: boolean;
  isAutoRefundEnabled: boolean;
}

interface ExternalAccountConfigRequest {
  token: string;
  columnFilters: string;
  sorting: string;
  page: string;
  pageSize: string;
  globalFilter: string;
}

const getExternalAccountConfig = async ({
  token,
  columnFilters,
  sorting,
  page = "1",
  pageSize = "10",
  globalFilter = "",
}: ExternalAccountConfigRequest): Promise<ExternalAccountConfigResponse> => {
  try {
    const response = await axios.get(
      `${getBaseUrl(Microservice.PAYMENT)}/payment/account/get-external-account-config`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        params: {
          columnFilters,
          sorting,
          page,
          pageSize,
          globalFilter,
        },
        withCredentials: true,
      },
    );

    return response.data;
  } catch (error) {
    const message = getApiResponseErrorMsg(error);
    throw new Error(message);
  }
};

export default getExternalAccountConfig;
